
import { Component, Mixins } from 'vue-property-decorator';
import TextInputComponent from '@/components/Forms/Elements/TextInputComponent.vue';
import FileUploadComponent from '@/components/Forms/Elements/FileUploadComponent.vue';
import DateSelectorComponent from '@/components/Forms/Elements/DateSelectorComponent.vue';
import ApplicationSectionMixin from '@/mixins/ApplicationSectionMixin';

@Component<ApplicationFormExceptionToPolicySection>({
  components: {
    DateSelectorComponent,
    FileUploadComponent,
    TextInputComponent
  }
})
export default class ApplicationFormExceptionToPolicySection extends Mixins(
  ApplicationSectionMixin
) {}
